import { isDate } from "lodash";
import {
  DateRange,
  isDateRange,
  Mode,
  PropsBase,
  PropsMulti,
  PropsMultiRequired,
  PropsRange,
  PropsRangeRequired,
  PropsSingle,
  PropsSingleRequired,
} from "react-day-picker";
import { PropsMultipleRange } from "./";

export type AcExpoDayPickerMode = Mode | "multiple-range";

export type AllDatePickerTypes = Date | Date[] | DateRange | DateRange[];

export interface AcExpoDayPickerPropsBase extends Omit<PropsBase, "mode"> {
  mode: AcExpoDayPickerMode | undefined;
}

export type AcExpoDayPickerProps = AcExpoDayPickerPropsBase &
  (
    | PropsSingle
    | PropsSingleRequired
    | PropsMulti
    | PropsMultiRequired
    | PropsRange
    | PropsRangeRequired
    | PropsMultipleRange
    | {
        mode?: undefined;
        required?: undefined;
      }
  );

export type OnPickTypeDateType<TMode extends AcExpoDayPickerMode> =
  TMode extends "range"
    ? DateRange
    : TMode extends "single"
      ? Date
      : TMode extends "multiple"
        ? Date[]
        : TMode extends "multiple-range"
          ? DateRange[]
          : never;

export const isOnPickTypeDateType = <TMode extends AcExpoDayPickerMode>(
  value: AllDatePickerTypes | undefined,
  type: TMode
): value is OnPickTypeDateType<TMode> => {
  if (type === "single" && isDate(value)) {
    return true;
  }
  if (type === "range" && isDateRange(value)) {
    return true;
  }
  if (type === "multiple" && Array.isArray(value) && value.every(isDate)) {
    return true;
  }
  return type === "multiple-range" &&
  Array.isArray(value) &&
  value.every(isDateRange);
};
